var map = {
	"./collection1.png": 74,
	"./hero.png": 75,
	"./services1.png": 76,
	"./services2.png": 77,
	"./services3.png": 78,
	"./services4.png": 79,
	"./services5.png": 80,
	"./servicesB.png": 36,
	"./works1.png": 81,
	"./works2.png": 82,
	"./works3.png": 83,
	"./works4.png": 84,
	"./works5.png": 85,
	"./works6.png": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;